



























































import { Component, Vue } from "@/shared/node_modules/vue-property-decorator";
import { CrudService } from "@/shared/core/services/crudService";
import { Settings } from "@/shared/core/services/configService";
import store from "@/shared/core/store";

@Component
export default class CoursesPage extends Vue {
  loading: boolean = true;
  courses: any[] = [];
  uploadsUrl: string = "";

  get customerId(): number {
    try {
      const raw = localStorage.getItem(window.location.host + "_cc");
      if (raw) {
        const parsed = JSON.parse(raw);
        const val = parsed.value || parsed;
        if (typeof val === "string") return JSON.parse(val).id;
        return val.id;
      }
    } catch (e) {}
    return 0;
  }

  async mounted() {
    this.uploadsUrl = store.state.settings?.Uploads || "";
    await this.loadCourses();
  }

  async loadCourses() {
    this.loading = true;
    const crud = new CrudService();
    const [allRes, myRes] = await Promise.all([
      crud.httpGet(`${Settings.HostName}/api/public-courses/list`),
      this.customerId
        ? crud.httpGet(`${Settings.HostName}/api/public-courses/my-courses`)
        : Promise.resolve(null)
    ]);
    const all = allRes?.data || [];
    const my = myRes?.data || [];
    const myMap: any = {};
    my.forEach((c: any) => { myMap[c.id] = c; });
    this.courses = all.map((c: any) => myMap[c.id] ? { ...c, ...myMap[c.id] } : c);
    this.loading = false;
  }

  openCourse(course: any) {
    this.$router.push(`/courses/${course.id}`);
  }

  posterUrl(c: any): string {
    if (!c.poster) return "";
    return c.poster.startsWith("http") ? c.poster : this.uploadsUrl + "/" + c.poster;
  }

  formatDuration(s: number): string {
    if (!s) return "0 min";
    return Math.round(s / 60) + " min";
  }
}
